import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import MainPage from './main';
import { HashRouter, Route, Link } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import 'core-js'; 

class Index extends Component {
  // componentWillMount() {
  //   window.addEventListener('hashchange', (state) => {
  //     const href = window.location.href
  //     if (href.indexOf('/main') < 0) {
  //       window.location.reload()
  //     }
  //   })
  // }

  // componentWillUnmount() {
  //   window.removeEventListener('hashchange')
  // }

  render() {
    return (
      <HashRouter>
        <div>
          <Route exact path="/" component={App}/>
          <Route path="/main" component={MainPage}/>
          <Link to="/"></Link>
          <Link to="/main"></Link>
        </div>
      </HashRouter>
    )
  }
}
// ReactDOM.render(<App />, document.getElementById('root'));
ReactDOM.render(<Index/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
